class Scroller {
	constructor(props = {}) {
		this.link = props?.link;
		this.block = props?.block;
		this.offset = this.block[0]?.getAttribute('data-offset-block') ? this.block[0]?.getAttribute('data-offset-block') : 0;
		this.linkDictionary = this.getLinkDictionary();
		this.blockDictionary = this.getBlockDictionary();
		this.init();
		console.log(this.linkDictionary);
	}

	init() {
		this.pageLoading();
		this.clickEvent();
		this.scrollEvent();
	}

	getLinkDictionary() {
		let dictionary = {};
		for (let item of this.link) {
			let attr = item.getAttribute('href');
			let index = attr.indexOf('#');
			attr = attr.slice(index + 1);
			dictionary[attr] = item;
		}

		return dictionary
	}

	getBlockDictionary() {
		let dictionary = {};
		for (let item of this.block) {
			let id = item.getAttribute('id');
			dictionary[id] = item;
		}

		return dictionary
	}

	getEl(el, attr, container) {
		let elements = document.querySelectorAll(el);

		if (container) {
			elements = container.querySelectorAll(el);
		}

		return [...elements];
	};

	getId(element) {
		element.preventDefault();
		let id = element.target.getAttribute('href');
		return id.slice(id.indexOf('#') + 1);
	}

	hideAndShowClass(element) {
		this.link.forEach(el => el.closest('li').classList.remove('active'));
		element.closest('li').classList.add('active');
	}

	scrollToSection(id) {
		const el = this.blockDictionary[id];
		let lengthSection = el.getBoundingClientRect().top + window.pageYOffset;
		window.scrollTo({
			top: lengthSection - this.offset,
			behavior: 'smooth'
		});
	}

	visibleSection(target, position, offset = 0) {
		let visible = false;
		const targetPosition = {
				top: window.pageYOffset + target.getBoundingClientRect().top,
				bottom: window.pageYOffset + target.getBoundingClientRect().bottom,
				center: window.pageYOffset + target.getBoundingClientRect().top,
			},
			windowPosition = {
				top: window.pageYOffset,
				bottom: window.pageYOffset + document.documentElement.clientHeight
			};

		if (position === 'top') {
			targetPosition.top -= offset;
			if (targetPosition.top < windowPosition.top &&
				windowPosition.top < targetPosition.bottom) {
				visible = true;
			}
		}

		if (position === 'bottom') {
			targetPosition.top += offset;
			if (targetPosition.bottom > windowPosition.top &&
				targetPosition.top < windowPosition.bottom) {
				visible = true;
			}
		}

		if (position === 'center') {
			if (targetPosition.center < windowPosition.top +
				(document.documentElement.clientHeight / 2) &&
				windowPosition.top < targetPosition.bottom) {
				visible = true;
			}
		}

		return visible;
	}

	pageLoading() {
		let hash = location.hash.slice(1);
		if (!hash) return;
		// history.pushState('', document.title, window.location.pathname);
		if (this.linkDictionary[hash]) {
			this.scrollToSection(hash);
		}
	}

	clickEvent() {
		this.link.forEach((element) => {
			element.addEventListener('click', (e) => {
				let id = this.getId(e);
				this.scrollToSection(id);
				this.hideAndShowClass(element);
			});
		});
	};

	scrollEvent() {
		if (window.innerWidth < 992) return;

		let tmScroll;
		window.addEventListener('scroll', () => {
			clearInterval(tmScroll);
			tmScroll = setTimeout(() => {
				this.block.forEach((el) => {
					let id = el.getAttribute('id');
					if (this.visibleSection(el, 'center')) {
						this.hideAndShowClass(this.linkDictionary[id]);
					}
				})
			}, 50);
		})
	}
}

const init = () => {
	const paramsSection = [
		{
			link: document.querySelectorAll('.services-page .list-navigation .list-item a'),
			block: document.querySelectorAll('.services-page .services-item'),
		},

		{
			link: document.querySelectorAll('.portfolios-page .list-navigation .list-item a'),
			block: document.querySelectorAll('.portfolios-page .portfolios-item'),
		},
	];


	paramsSection.filter(el => el.link.length !== 0 && el.block.length !== 0)
		.map((el) => {
			new Scroller({
				link: [...el.link],
				block: [...el.block],
			});
		})
};

init();